// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  tier: __t.string(),
  worldQuota: __t.u8().name("world_quota"),
  priceCapSov: __t.i64().name("price_cap_sov"),
  forgeAccess: __t.bool().name("forge_access"),
  analytics: __t.bool(),
  updatedAt: __t.timestamp().name("updated_at"),
});
